function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { validate } from 'class-validator';
export function validatable(target) {
  var _class, _descriptor, _descriptor2;
  return _class = class _class extends target {
    constructor(...args) {
      super(...args);
      _initializerDefineProperty(this, "_evdVisibleErrors", _descriptor, this);
      _initializerDefineProperty(this, "_evdShowAllErrors", _descriptor2, this);
    }
    async validate() {
      const errors = await validate(this);
      const errorsByField = errors.reduce((acc, {
        property,
        constraints
      }) => {
        acc[property] = Object.values(constraints);
        return acc;
      }, {});
      errorsByField._hasErrors = errors.length > 0;
      return errorsByField;
    }
    async isValid(field = null) {
      return !(await this.isInvalid(field));
    }
    async isInvalid(field = null) {
      const errors = await this.validate();
      if (field === null) {
        return errors._hasErrors;
      }
      return field in errors;
    }
    async getErrorsFor(field) {
      if (this._evdShowAllErrors || this._evdVisibleErrors.includes(field)) {
        const errors = await this.validate();
        if (field in errors) {
          return errors[field];
        }
      }
      return [];
    }
    async hasErrorFor(field) {
      const errors = await this.getErrorsFor(field);
      return errors.length > 0;
    }
    addErrorDisplaysFor(fields) {
      fields.forEach(field => this.addErrorDisplayFor(field));
    }
    addErrorDisplayFor(field) {
      if (!this._evdVisibleErrors.includes(field)) {
        this._evdVisibleErrors = [...this._evdVisibleErrors, field];
      }
    }
    addErrorDisplayForAllFields() {
      this._evdShowAllErrors = true;
    }
    clearErrorDisplay() {
      this._evdShowAllErrors = false;
      this._evdVisibleErrors = [];
    }
    removeErrorDisplayFor(field) {
      if (this._evdVisibleErrors.includes(field)) {
        this._evdShowAllErrors = false;
        this._evdVisibleErrors = this._evdVisibleErrors.filter(f => f !== field);
      }
    }
  }, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_evdVisibleErrors", [tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_evdShowAllErrors", [tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "validate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "validate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [action], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isInvalid", [action], Object.getOwnPropertyDescriptor(_class.prototype, "isInvalid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getErrorsFor", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getErrorsFor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasErrorFor", [action], Object.getOwnPropertyDescriptor(_class.prototype, "hasErrorFor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addErrorDisplaysFor", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addErrorDisplaysFor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addErrorDisplayFor", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addErrorDisplayFor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addErrorDisplayForAllFields", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addErrorDisplayForAllFields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearErrorDisplay", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearErrorDisplay"), _class.prototype), _class;
}